import React from "react";
import DocFilePreview from "./DocFilePreview";
import styled from "styled-components";
import { EyeViewIcon, RedCrossIcon } from "../svgExport";

function FilePreview({
  handleDeleteResource,
  fileResources,
}: {
  handleDeleteResource?: any;
  fileResources?: any;
}) {
  const [zoomedImage, setZoomedImage] = React.useState<string | null>(null);

  if (fileResources?.length === 0) {
    return null;
  }

  const onDelete = (
    event: React.MouseEvent<HTMLDivElement, MouseEvent>,
    url: string
  ) => {
    event.stopPropagation();
    handleDeleteResource(url);
  };

  const imagesFormat = ["png", "jpg", "jpeg"];
  const videosFormat = ["mp4"];
  const documentFormat = ["doc", "docx", "csv", "xlsx", "pdf"];

  const docResources = fileResources?.filter((file: any) =>
    documentFormat.some((ext) => file?.file_path?.includes(ext))
  );
  const imageVideoResources = fileResources?.filter((file: any) =>
    [...imagesFormat, ...videosFormat].some((ext) =>
      file?.file_path?.includes(ext)
    )
  );

  return (
    <div>
      {/* Image Preview */}
      {imageVideoResources?.length > 0 && (
        <ImagePreviewList>
          {imageVideoResources?.map((file: any) => {
            return (
              <ImagePreviewListItem
                key={`${file?.file_name} - ${file?.file_path}`}
              >
                <Image
                  src={file?.url || file?.preview || file?.download}
                  width={50}
                  height={50}
                />
                <IconContainer
                  onClick={(e: React.MouseEvent<HTMLDivElement, MouseEvent>) =>
                    onDelete(
                      e,
                      file?.download || file?.preview || file?.file_reference
                    )
                  }
                >
                  <RedCrossIcon />
                </IconContainer>

                <IconCenterContainer
                  onClick={(e: any) => {
                    e.stopPropagation();
                    setZoomedImage(
                      file?.url || file?.preview || file?.download
                    );
                  }}
                >
                  <EyeViewIcon />
                </IconCenterContainer>
              </ImagePreviewListItem>
            );
          })}
        </ImagePreviewList>
      )}
      {/* Doc Preview */}
      {docResources?.length > 0 && (
        <DocPreviewList>
          {docResources.map((x: any, index: number) => (
            <DocFilePreview file={x} key={index} onDelete={onDelete} />
          ))}
        </DocPreviewList>
      )}

      <StyledZoom>
        {zoomedImage && (
          <div className="zoom-overlay" onClick={() => setZoomedImage(null)}>
            <div className="zoom-content" onClick={(e) => e.stopPropagation()}>
              <img src={zoomedImage} alt="Zoomed" className="zoomed-image" />
            </div>
          </div>
        )}
      </StyledZoom>
    </div>
  );
}
const IconCenterContainer = styled.div`
  position: absolute;
  top: 17px;
  right: 17px;
  background: #fff;
  border-radius: 100px;
  padding: 4px;
  width: 16px;
  height: 16px;
  display: flex;
  align-items: center;
  cursor: pointer;
`;
const StyledZoom = styled.div`
  .zoom-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.7);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 999;
  }

  .zoom-content {
    max-width: 90%;
    max-height: 90%;
  }

  .zoomed-image {
    max-width: 100%;
    max-height: 100%;
    border-radius: 8px;
  }
`;

const Image = styled.img`
  border: 1px solid #c7d3e1;
  border-radius: 8px;
`;

const IconContainer = styled.div`
  position: absolute;
  top: 3px;
  right: 4px;
  background: #fff;
  border-radius: 100px;
  padding: 4px;
  width: 16px;
  height: 16px;
  display: flex;
  align-items: center;
  cursor: pointer;
`;

const ImagePreviewListItem = styled.li`
  position: relative;
`;

const ImagePreviewList = styled.ul`
  display: flex;
  gap: 20px;
  padding: 10px;
  flex-wrap: wrap;
`;

const DocPreviewList = styled.ul`
  padding: 10px 0px;
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

export default FilePreview;
